export enum ApiRequest {
  SignIn = `SignIn`,
  SignOut = `SignOut`,
  ForgotPassword = `ForgottenPasswordAuthorisationCodeRequest3`,
  ForgotPasswordSubmit = `ForgottenPasswordReset1`,
  ClientDetailsGet1 = `ClientDetailsGet1`,
  ClientAuthenticate3 = `ClientAuthenticate3`,
  ClientRolesGet1 = `ClientRolesGet1`,
  ClientProSubscriptionGet1 = `ClientProSubscriptionGet1`,
  ClientProfileSettingGet1 = `ClientProfileSettingGet1`,
  ClientPendingOnlineApplicationsGet1 = `ClientPendingOnlineApplicationsGet1`,
  StockFilterQueriesGet2 = `StockFilterQueriesGet2`,
  RecentStocksGet2 = 'RecentStocksGet2',
  ClientLogout1 = `ClientLogout1`,
  InterceptorProcess1 = `InterceptorProcess1`,
  InterceptorTokenProcess = `InterceptorTokenProcess`,
  InternationalCountriesGet1 = `InternationalCountriesGet1`,
  SelectedCountryUpdate1 = `SelectedCountryUpdate1`,
  ClientDetailsUpdate2 = `ClientDetailsUpdate2`,
  SessionCheck1 = `SessionCheck1`,
  ClientDisableFalconAccess1 = 'ClientDisableFalconAccess1',
  ClientFeedbackAdd1 = 'ClientFeedbackAdd1',
  ClientProfileSettingSave1 = 'ClientProfileSettingSave1',
  StockLendingShowInterceptorGet1 = `StockLendingShowInterceptorGet1`,
  ValidateAuthorisationCode1 = `ValidateAuthorisationCode1`,
  RequestPasswordReset1 = `RequestPasswordReset1`,
  SalesforceCaseAdd1 = `SalesforceCaseAdd1`
}
